import { render, staticRenderFns } from "./RankingGroups.vue?vue&type=template&id=34c0075c&"
import script from "./RankingGroups.vue?vue&type=script&lang=js&"
export * from "./RankingGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports